import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { logIn, fetch, cadastrarGrupo } from "../../actions";
import * as api from "./AuthApi";
import { InputPadrao, LabelPadrao } from "../../components/Base";
import Mensagens from "../../components/Mensagens";
import { useSave } from "../../components/Hooks/Conexao";
import { Button } from "antd";
import Fundo from "../../assets/login_bg.png";
import { useHistory, useLocation } from "react-router-dom";

const INITIAL_DEFAULT = { chavePdv: undefined, chave: undefined };

function CadastroGrupo(props) {
    const [login, setLogin] = useState(INITIAL_DEFAULT);

    const { search } = useLocation();
    const history = useHistory();

    const acessoRevogado = props.acessoRevogado;

    const [cadastrar, cadastrando] = useSave(() => api.register(props.fetch, login), res => {
        if (res?.errorMsg)
            Mensagens.showErro(res.errorMsg);

        props.cadastrarGrupo(res);
    }, { onRejected: error => { Mensagens.showErro(error); } });

    function salvar(e) {
        e.preventDefault();
        if (!login.chave) return Mensagens.showErro("Chave não informada!");
        if (!login.chavePdv) return Mensagens.showErro("Chave pdv não informada!");
        cadastrar();
    }

    useEffect(() => {
        const query = new URLSearchParams(search);

        const versao = query.get("versao");
        const chave = query.get("chave");
        const token = query.get("token");
        const pdv = query.get("pdv");

        if (!!token)
            history.push(`/token/${versao}/${chave}/${pdv}/${token}`);

        if (acessoRevogado)
            setTimeout(() => Mensagens.showWarning("Este caixa teve seu acesso revogado, por favor cadastre novamente."), 100);
    }, []);

    return <div style={{ height: "100vh", background: `url(${Fundo}) no-repeat`, backgroundSize: "cover", backgroundColor: "#fff", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <form onSubmit={salvar}>
            <div style={{ width: 600, borderRadius: 4, padding: 30, marginTop: -100 }}>
                <h3 style={{ textAlign: "center" }}>{acessoRevogado ? "Recadastrar PDV" : "Cadastrar PDV"}</h3>
                <div>
                    <LabelPadrao>Chave</LabelPadrao>
                    <InputPadrao style={{ background: "transparent", color: "#333", width: "100%" }} value={login.chave} onChange={v => setLogin({ ...login, chave: v.target.value })} placeholder="Insira a chave" />
                </div>
                <div>
                    <LabelPadrao>Chave PDV</LabelPadrao>
                    <InputPadrao style={{ background: "transparent", color: "#333", width: "100%" }} value={login.chavePdv} onChange={v => setLogin({ ...login, chavePdv: v.target.value })} placeholder="Insira a chave pdv" />
                </div>
                <Button data-cy="btn-login" type="primary" style={{ width: "100%", background: "#fff", color: "#333", fontWeight: "bold", borderColor: "#ddd", borderRadius: 20, marginTop: 10 }} htmlType="submit" loading={cadastrando}>
                    {cadastrando ? `${acessoRevogado ? 'Recadastrando' : 'Cadastrando'}...` : `${acessoRevogado ? 'Recadastrar' : 'Cadastrar'}`}
                </Button>
            </div>
        </form>
    </div>;
}
const mapStateToProps = state => ({ acessoRevogado: state.auth.acessoRevogado });

export default connect(mapStateToProps, { logIn, fetch, cadastrarGrupo })(CadastroGrupo);